<template>
  <ul class="order">
    <li class="order-tip">
      <p>题号颜色说明：</p>
      <div class="order-item order-current">当前题目</div>
      <div class="order-item order-passed">已答题目</div>
      <div class="order-item">未答题目</div>
    </li>
    <li class="order-tip margin-bottom-10px text-gray">
      * 点击下方题号可直接跳转到相应题目
    </li>

    <li class="order-item"
      v-for="(item, index) in paper" :key="index"
      :class="orderClassRender(item, index)"
      @click="handleOrderClicked(index)">
      {{ index + 1 }}
    </li>
  </ul>
</template>

<script>
import { mapState } from 'vuex'
import { EXAMINATION } from '../../../libs/namespace'

export default {
  props: {
    value: {
      type: Number,
      required: true
    }
  },
  data () {
    return {}
  },
  computed: {
    ...mapState(EXAMINATION, [ 'paper', 'answers' ])
  },
  handlers: {
    handleOrderClicked (index) {
      this.$emit('input', index)
    }
  },
  methods: {
    orderClassRender (item, index) {
      if (index === this.value) return 'order-current'
      if (this.answers[index].length) return 'order-passed'
    }
  }
}
</script>

<style lang="less" scoped>
.order {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;

  &-item {
    flex: none;
    width: 40px;
    height: 20px;
    margin: 5px;
    text-align: center;
    line-height: 20px;
    font-weight: bold;
    cursor: pointer;
    background: #f8f8f9;
  }
  &-current {
    color: #ffffff;
    background: #2db7f5;
  }
  &-passed {
    color: #ffffff;
    background: #19be6b;
  }
  &-empty {
    color: #ffffff;
    background: #ff9900;
  }

  &-tip {
    flex: none;
    display: flex;
    // justify-content: flex-end;
    align-items: center;
    width: 100%;

    .order-item {
      width: auto;
      padding: 0 5px;
      cursor: auto;
    }
  }
}
</style>

